import * as React from "react";
import "./UserCenter.less";
import {Tabs} from "antd";
import {injectIntl, InjectedIntlProps} from "react-intl";
import UserInf from "./UserInf";
import UserPassword from "./UserPassword";
const { TabPane } = Tabs;

export type UserCenterProps = InjectedIntlProps;

class UserCenter extends React.Component<UserCenterProps, {}> {
    public constructor(props: UserCenterProps) {
        super(props);
    }

    public render(): React.ReactNode {
        return (
            <div className="product-center-box">
            <div className="portal-room-outbox">
                <div className="portal-room-chart">
                    <div className="portal-room-box-mid">
                    <Tabs style={{marginLeft: 20, marginRight: 20}} defaultActiveKey="1" >
                        <TabPane tab="基本信息" key="1">
                            <UserInf/>
                        </TabPane>
                        <TabPane tab="更改密码" key="2">
                            <UserPassword/>
                        </TabPane>
                    </Tabs>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default injectIntl(UserCenter);



// WEBPACK FOOTER //
// ./src/components/portal/userCenter/UserCenter.tsx